/**
 * Tailwind CSS implementation of ChatBubble component
 * Uses Seeds chat-bubble CSS classes from chat-bubble.css
 */

import * as React from "react";
import type { TypeChatBubbleProps } from "./ChatBubbleTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const ChatBubbleTailwind = ({
  children,
  type = "received",
  size = "default",
  className,
  ...rest
}: TypeChatBubbleProps) => {
  const classes = cn(
    "seeds-chat-bubble",
    `seeds-chat-bubble-${type}`,
    `seeds-chat-bubble-${size}`,
    className
  );

  return (
    <div
      className={classes}
      data-qa-chat-bubble
      {...(rest as React.ComponentPropsWithoutRef<"div">)}
    >
      {children}
    </div>
  );
};

ChatBubbleTailwind.displayName = "ChatBubbleTailwind";
